export enum OENLoadingOutcome {
  SUCCESS,
  ERROR,
  WARNING_CONTINUE,
  WARNING_BREAK,
}
